import script from "./AudioPlayerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioPlayerModal.vue?vue&type=script&setup=true&lang=js"

import "./AudioPlayerModal.vue?vue&type=style&index=0&id=af5250c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af5250c6"]])

export default __exports__